import React from 'react'
import Contact from './Contact';
import Price from './Price';
import Services from './Services';
import Slider from './Slider';
import About from './About';
import Team from './Team';
import Testimonials from './Testimonials';
import Statistics from './Statistics';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function Home() {
    useScrollAnimation();
    
    return (
        <div>
            <Slider />
            <About />
            <Statistics />
            <Services />
            <Price />
            <Team />
            <Testimonials />
            <Contact />
        </div>
    )
}
